
  <!-- Sidebar -->
  <app-sidebar></app-sidebar>
  <div >
    <app-header></app-header> 
    <!-- Page Content -->
    <div id="content">
        <app-protocolo></app-protocolo> 
    </div>
    <app-footer></app-footer>
</div>
